import { render, staticRenderFns } from "./AddedArticleInfo.vue?vue&type=template&id=5ecfbeb9&"
import script from "./AddedArticleInfo.vue?vue&type=script&lang=js&"
export * from "./AddedArticleInfo.vue?vue&type=script&lang=js&"
import style0 from "./AddedArticleInfo.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports